<ds-simple-metadata-section  [mdValues]="fields | metaTranslate: item" [separator]="separator" [label]="label" [isDescriptionList]="isDescriptionList"></ds-simple-metadata-section>
